<div style="padding: 20px;">
  <h2 mat-dialog-title style="margin:0;">Alterar senha</h2>

  <div mat-dialog-content style="overflow: inherit;">
    <form [formGroup]="form" class="form-fields">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Senha atual</mat-label>
        <input matInput [type]="hideOld ? 'password' : 'text'" formControlName="oldPassword" autocomplete="current-password">
        <button mat-icon-button matSuffix type="button" (click)="hideOld = !hideOld" [attr.aria-label]="'toggle old password'">
          <mat-icon>{{ hideOld ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <mat-error *ngIf="f['oldPassword'].hasError('required')">Informe a senha atual.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Nova senha</mat-label>
        <input matInput [type]="hideNew ? 'password' : 'text'" formControlName="newPassword" autocomplete="new-password">
        <button mat-icon-button matSuffix type="button" (click)="hideNew = !hideNew" [attr.aria-label]="'toggle new password'">
          <mat-icon>{{ hideNew ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <mat-hint align="start">Mínimo de 8 caracteres.</mat-hint>
        <mat-error *ngIf="f['newPassword'].hasError('required')">Informe a nova senha.</mat-error>
        <mat-error *ngIf="f['newPassword'].hasError('minlength')">A nova senha deve ter no mínimo 8 caracteres.</mat-error>
        <mat-error *ngIf="form.hasError('sameAsOld')">A nova senha deve ser diferente da senha atual.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Confirmar nova senha</mat-label>
        <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmNewPassword" autocomplete="new-password">
        <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm" [attr.aria-label]="'toggle confirm password'">
          <mat-icon>{{ hideConfirm ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <mat-error *ngIf="f['confirmNewPassword'].hasError('required')">Confirme a nova senha.</mat-error>
        <mat-error *ngIf="form.hasError('passwordsDontMatch')">As senhas não conferem.</mat-error>
      </mat-form-field>
    </form>
  </div>

  <mat-dialog-actions class="action-buttons">
    <button class="back-btn" (click)="close()" [disabled]="isLoading">Cancelar</button>
    <button class="continue-btn" (click)="save()" [disabled]="form.invalid || isLoading">
      {{ isLoading ? 'Salvando...' : 'Salvar' }}
    </button>
  </mat-dialog-actions>
</div>
